import { UserContext } from 'contexts/userContext';
import { IPaginate, TArticle, TLike, TUser } from 'models/common';
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import dbService from 'services/database.service';

const useLike = (article: TArticle) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const [like, setLike] = useState<TLike | null>();
  const [totalLikeCount, setTotalLikeCount] = useState(0);
  const [likesMiniData, setLikesMiniData] = useState<TLike[]>([]);

  useEffect(() => {
    if (!article._id) {
      return;
    }

    getLikes();

    if (!user?._id) {
      return;
    }

    dbService.getLikes({
      filter: { article: article._id, user: user._id },
      relation: true,
    }).then(res => setLike(res?.[0]))
  }, [])

  const handleLike = async () => {
    if (!user?._id) {
      navigate('/login');
      return;
    }

    const isLiked = !!like;
    if (!isLiked) {
      await dbService.insertLike({ article: article._id, user: user._id })
        .then(res => {
          insertNotification();
          setLike(res);
        })
      getLikes();
      return;
    }

    await dbService.removeLike(like._id!).then(_ => {
      setLike(null)
      getLikes();
    })
  }

  const getLikes = () => {
    dbService
      .getLikes({
        filter: { article: article._id },
        limit: 3,
        paginate: true,
        relation: true,
      })
      .then((res) => {
        const resPaginate = res as unknown as IPaginate<TLike>;
        if (!resPaginate) return;
        setTotalLikeCount(resPaginate.meta.total);
        setLikesMiniData(resPaginate.data);
      });
  };

  const insertNotification = () => {
    if (user._id === (article.publisher as TUser)._id) return;
    dbService.insertActivity({
      user: user._id,
      target_user: article.publisher,
      action: 'like_post',
      target_article: article._id
    });
  }

  return { isLiked: !!like, likesMiniData, totalLikeCount, handleLike };
};

export default useLike;
